import React, { useState,useContext } from "react";
import { Modal } from "@mui/material";
import "../components/CompleteClassDetails.css";
import {StudentDetailsContext} from "../store/student-details";
import DoneIcon from '@mui/icons-material/Done';
const ModalComponent = ({ className, editStudent, addStudent ,onClickCancel,editDetailsObj,addStudentDetailsHandler,updateStudentDetailsHandler}) => {
  //   const [addStudent, setAddStudent] = useState(true);
  const StudentContext = useContext(StudentDetailsContext);
  const[updateStatus,setIsUpdateStatus] = useState(false);
    const{Name,AdmissionNumber,FatherName,MotherName,Dob,AdmissionDate,AadharNumber,MobileNumber} = editDetailsObj;
  const [studentDetailsObj, setStudentDetailsObj] = useState({
    Name: "",
    FatherName: "",
    MotherName: "",
    Dob: "",
    AdmissionDate: "",
    AadharNumber: "",
    MobileNumber: "",
    AdmissionNumber: "",
  });

  const[updateDetails,setUpdateDetailsObj] = useState({
    Name : Name,
    FatherName:FatherName,
    MotherName:MotherName,
    Dob:Dob,
    AdmissionDate:AdmissionDate,
    AdmissionNumber:AdmissionNumber,
    AadharNumber:AadharNumber,
    MobileNumber:MobileNumber
  })

 
  function updateStudentDetails(e,data){
    e.preventDefault();
    console.log('Updating details');
    console.log('Updating class :'+className);
    console.log('Updating Id :'+data.AdmissionNumber);
    updateStudentDetailsHandler(className,data.AdmissionNumber,data);
    setIsUpdateStatus(true);
  }
  function addUserHandlerFunction(e) {
    e.preventDefault();
    console.log(studentDetailsObj.Name);
    console.log(studentDetailsObj.AdmissionNumber);
    console.log(studentDetailsObj.FatherName);
    console.log(studentDetailsObj.MotherName);
    console.log(studentDetailsObj.Dob);
    console.log(studentDetailsObj.AdmissionDate);
    console.log(studentDetailsObj.AadharNumber);
    console.log(studentDetailsObj.MobileNumber);
    addStudentDetailsHandler(studentDetailsObj,className);
  }

  return (
    <>
      {editStudent ? (
        <>
          <Modal open={editStudent}>
            <div className="addStudentModal col-lg-12">
              <div className="card my-5 p-4 formCard">
                <div className="addingInfoText">
                  <p className="mt-2">
                    You are Editing  {editDetailsObj.Name} with Admission Number {editDetailsObj.AdmissionNumber}
                  </p>
                  <button
                    className="closeBtn"
                    // onClick={() => setAddStudent(false)}
                    onClick = {onClickCancel}
                  >
                    X
                  </button>
                </div>
                <br />
                <form
                  className="form"
                  onSubmit={(e)=>updateStudentDetails(e,updateDetails)}
                >
                  <div className="form-group">
                    <label>Admission Number</label>
                    <input
                      type="text"
                      placeholder="enter admission number"
                      className="form-control"
                      name="AdmissionNumber"
                     value={updateDetails.AdmissionNumber}
                     onChange={(e) => {
                        setUpdateDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Student Name</label>
                    <input
                      type="text"
                      placeholder="enter student name"
                      className="form-control"
                      name="Name"
                      value={updateDetails.Name}
                      onChange={(e) => {
                        setUpdateDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label>Father Name</label>
                    <input
                      type="text"
                      placeholder="enter father name"
                      className="form-control"
                      name="FatherName"
                      value={updateDetails.FatherName}
                      onChange={(e) => {
                        setUpdateDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label>Mother Name</label>
                    <input
                      type="text"
                      placeholder="enter mother name"
                      className="form-control"
                      name="MotherName"
                      value={updateDetails.MotherName}
                      onChange={(e) => {
                        setUpdateDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label>DOB</label>
                    <input
                      type="date"
                      placeholder="dd-mm-yy"
                      className="form-control"
                      name="Dob"
                      value={updateDetails.Dob}
                      onChange={(e) => {
                        setUpdateDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Admission Date</label>
                    <input
                      type="date"
                      placeholder="dd-mm-yy"
                      className="form-control"
                      name="AdmissionDate"
                      value={updateDetails.AdmissionDate}
                      onChange={(e) => {
                        setUpdateDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Aadhar Number</label>
                    <input
                      type="text"
                      placeholder="enter aadhar number"
                      className="form-control"
                      name="AadharNumber"
                      value={updateDetails.AadharNumber}
                      onChange={(e) => {
                        setUpdateDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Mobile Number</label>
                    <input
                      type="text"
                      placeholder="enter mobile number"
                      className="form-control"
                      name="MobileNumber"
                      value={updateDetails.MobileNumber}
                      onChange={(e) => {
                        setUpdateDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="d-flex flex-row justify-content-center mt-3">
                  
                    {updateStatus ? <>
                      <button type="submit" className="btn btn-sm btn-success px-5"
                    >
                      Details Updated &nbsp; <DoneIcon/>
                    </button>
                    </>:<>
                   {!updateStatus ? <>
                    <button type="submit" className="btn btn-sm btn-info px-5"
                    >
                      Update Details
                    </button>
                   </> : <>
                    
                   </>}
                    </>}
                  </div>
                </form>
              </div>
            </div>
          </Modal>{" "}
        </>
      ) : (
        <>
          <Modal open={addStudent}>
            <div className="addStudentModal col-lg-12">
              <div className="card my-5 p-4 formCard">
                <div className="addingInfoText">
                  <p className="mt-2">
                    You are adding student details to class {className}
                  </p>
                  <button
                    className="closeBtn"
                    // onClick={() => setAddStudent(false)}
                    onClick = {onClickCancel}

                  >
                    X
                  </button>
                </div>
                <br />
                <form
                  className="form"
                  onSubmit={(e) => addUserHandlerFunction(e)}
                >
                  <div className="form-group">
                    <label>Admission Number</label>
                    <input
                      type="text"
                      placeholder="enter admission number"
                      className="form-control"
                      name="AdmissionNumber"
                      onChange={(e) => {
                        setStudentDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Student Name</label>
                    <input
                      type="text"
                      placeholder="enter student name"
                      className="form-control"
                      name="Name"
                      onChange={(e) => {
                        setStudentDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label>Father Name</label>
                    <input
                      type="text"
                      placeholder="enter father name"
                      className="form-control"
                      name="FatherName"
                      onChange={(e) => {
                        setStudentDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label>Mother Name</label>
                    <input
                      type="text"
                      placeholder="enter mother name"
                      className="form-control"
                      name="MotherName"
                      onChange={(e) => {
                        setStudentDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label>DOB</label>
                    <input
                      type="date"
                      // placeholder="dd-mm-yy"
                      className="form-control"
                      name="Dob"
                      onChange={(e) => {
                        setStudentDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Admission Date</label>
                    <input
                      type="date"
                      placeholder="dd-mm-yy"
                      className="form-control"
                      name="AdmissionDate"
                      onChange={(e) => {
                        setStudentDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Aadhar Number</label>
                    <input
                      type="text"
                      placeholder="enter aadhar number"
                      className="form-control"
                      name="AadharNumber"
                      onChange={(e) => {
                        setStudentDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label>Mobile Number</label>
                    <input
                      type="text"
                      placeholder="enter mobile number"
                      className="form-control"
                      name="MobileNumber"
                      onChange={(e) => {
                        setStudentDetailsObj((prevDetails) => ({
                          ...prevDetails,
                          [e.target.name]: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="d-flex flex-row justify-content-center mt-3">
                    {StudentContext.created ? <>
                      <button type="submit" className="btn btn-sm btn-success px-5"
                    >
                      Details Added &nbsp; <DoneIcon/>
                    </button>
                    </> :<>
                    <button type="submit" className="btn btn-sm btn-info px-5"
                    >
                      Add Details
                    </button>
                    </>}
                  </div>
                </form>
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default ModalComponent;
